import { TypedUseSelectorHook, useSelector } from 'react-redux';

export type DefaultReducersReduxState = {
    relayVariables: {
        variables: {
            afterDisplay?: boolean;
            first?: number;
            showLoading?: boolean;
            userId?: string;
            personalizationId?: string;
            itemId?: string;
            isClient: boolean;
            isMultiSku?: boolean;
            fetchAuction?: boolean;
            fetchUser?: boolean;
            isTrade?: boolean;
            priceBookName: string;
            updateAuctionItem?: boolean;
            updatedUserCountryCode?: string;
            updateItemPricing?: boolean;
            includeSponsoredItems?: boolean;
            userCountryCode?: string;
            followSearchPages?: (string | null)[];
            showSeller: boolean;
        };
    };
    header: {
        updateUserState?: boolean;
    };
    displayPreferences: {
        showMeasurements: boolean;
    };
    filters: {
        filtersShown: boolean;
        generatedUriRef: string | null;
        page: number;
        refetchInFlight: boolean;
        zipCode: string;
        userZipCode: string;
        hasNewFilterUpdates: boolean;
        triggerType: string | null;
    };
};

export const useSbSelector: TypedUseSelectorHook<DefaultReducersReduxState> = useSelector;
